module.exports = __webpack_public_path__ + "img/8.e039dba0.jpg";